import FormattedDate from '../FormattedDate'

export function createCustomCellWithFormattedDate(field) {
    const format = field.meta?.format
    const customCell =
        format === 'date-string'
            ? {
                sortDescFirst: true,
                Cell: (cell) => <FormattedDate value={cell.value} />,
            } : null
    return customCell
}
